/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";


function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <div>
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
         <ListItem className={classes.inlineBlock}>
              Copyright &copy; {1900 + new Date().getYear()}, Myanmar Gateway
              Engineering & Consultancy Pte Ltd.
            </ListItem>
            <ListItem className={classes.inlineBlock}>
                <Link to="/civil">
                <a className={classes.block} target="_blank">
                  Services
                </a>
              </Link>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <Link to="/projects">
                <a className={classes.block} target="_blank">
                  Projects
                </a>
              </Link>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <Link to="/about">
                <a className={classes.block} target="_blank">
                  About
                </a>
              </Link>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <Link to="/contact">
               <a className={classes.block} target="_blank">
                  Contact
                </a>
              </Link>
            </ListItem>     
          </List>
        </div>
        </div>

        

    </footer>
 
    </div>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx